import { render, staticRenderFns } from "./SocialMedia.vue?vue&type=template&id=55d28396&scoped=true"
import script from "./SocialMedia.vue?vue&type=script&lang=js"
export * from "./SocialMedia.vue?vue&type=script&lang=js"
import style0 from "./SocialMedia.vue?vue&type=style&index=0&id=55d28396&prod&scoped=true&lang=scss"
import style1 from "./SocialMedia.vue?vue&type=style&index=1&id=55d28396&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d28396",
  null
  
)

export default component.exports